import type { FC } from "react";
import clsx from "clsx";
import { useLocale } from "hooks";
import { useFormContext, Controller } from "react-hook-form";
import Select from "react-select";
import type { Props as SelectProps } from "react-select";

interface SelectComponentProps {
  label: string;
  placeholder: string;
  options: SelectProps["options"];
  name: string;
}

const SelectComponent: FC<SelectComponentProps> = ({
  label,
  placeholder,
  options,
  name,
}) => {
  const { control } = useFormContext();
  const { isRTL } = useLocale();
  return (
    <div>
      <label className="tw-font-bold tw-text-[13px] xxxl:tw-text-[17.33px] tw-text-[#344456]">
        {label}
      </label>
      <Controller
        control={control}
        name={name}
        render={({ field: { onChange, value, name, ref } }) => (
          <div className="tw-relative">
            <Select
              key={value}
              name={name}
              placeholder={placeholder}
              className="tw-mt-2.5"
              inputRef={ref}
              classNamePrefix="addl-class"
              options={options}
              value={value}
              onChange={onChange}
              isSearchable={false}
              styles={{
                control: (provided, state) => ({
                  ...provided,
                  padding: "6px 2px",
                  borderColor: "rgb(52 68 86 / 0.2)",
                  color: "#344456",
                  minHeight: "50px",
                  borderRadius: "6px",
                }),
                indicatorSeparator: (provided) => ({
                  ...provided,
                  display: "none",
                }),
                dropdownIndicator: (provided) => ({
                  display: "none",
                }),
                placeholder: (provided) => ({
                  ...provided,
                }),
              }}
            />
            <svg
              className={clsx("tw-absolute tw-top-5 tw-pointer-events-none", {
                "tw-left-4": isRTL,
                "tw-right-4": !isRTL,
              })}
              width="12"
              height="8"
              viewBox="0 0 12 8"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M5.50595 7.2984C5.561 7.36057 5.63466 7.41141 5.72058 7.44653C5.8065 7.48165 5.90212 7.5 5.99919 7.5C6.09626 7.5 6.19187 7.48165 6.27779 7.44653C6.36372 7.41141 6.43738 7.36057 6.49243 7.2984L11.8928 1.23215C11.9554 1.16218 11.992 1.08023 11.9988 0.995195C12.0057 0.910163 11.9824 0.825302 11.9315 0.749833C11.8807 0.674365 11.8042 0.611175 11.7105 0.567129C11.6167 0.523083 11.5092 0.499866 11.3996 0.500001H0.598764C0.489461 0.500352 0.38235 0.523867 0.288948 0.568019C0.195546 0.61217 0.119388 0.675286 0.0686635 0.75058C0.0179391 0.825874 -0.00543232 0.910497 0.00106256 0.995348C0.00755745 1.0802 0.0436729 1.16207 0.105525 1.23215L5.50595 7.2984Z"
                fill="#222222"
              />
            </svg>
          </div>
        )}
      />
    </div>
  );
};

export default SelectComponent;
